<mat-dialog-content>
  @if(wasatch){
    <p> You are about to pay a total of <span style="font-weight: bold;">${{ amount1 }}</span> across all individual line items. Please note: These will appear as separate transactions on your bank statement.</p>
    <p style="font-weight: bold;">If you are making a same-day payment, you will not be able to cancel once you click 'Yes'. Are you sure you want to proceed?</p> 
  }
  @if(!wasatch){
    <p>You are about to pay the total amount of <span style="font-weight: bold;">${{ amount1 }}</span>. Are you sure you want to continue?</p>
    <p style="font-weight: bold;">If you are making a same day payment, you will not be able to cancel once you click "Yes".</p> 
  }  
</mat-dialog-content>

<mat-dialog-actions>
  @if(agentView){
    <button style="float: right;" mat-button disabled>Yes</button>
    <button style="float: right;" mat-button disabled>No</button>
  }
  @if(!agentView){
    <button style="float: right;" mat-button (click)="onOk()">Yes</button>
    <button style="float: right;" mat-button (click)="onCancel()">No</button>
  }
</mat-dialog-actions>
